import axios from 'axios';


const API = axios.create({
  // baseURL: "http://localhost:8000/api",
  baseURL: "https://db-api.sarilinggroup.com/api",
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default API;
